import styled from "@mui/material/styles/styled";

import Tab from "@mui/material/Tab";

export const StyledTab = styled(Tab)(({ theme: _ }) => ({
  width: "25%",
}));
